declare namespace $ {

	export class $mol_icon_pound extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=pound.view.tree.d.ts.map